import './Styles/ContractorsPage.css'

import { useState } from 'react'
import { useAuth } from '../../Providers/AuthProvider.jsx'
import { useCustomer } from '../../Providers/CustomerProvider.jsx'
import YesNoMessageModal from '../../Components/Components/Modals/YesNoMessageModal.jsx'
import { toast } from 'react-toastify'
import { useShop } from '../../Providers/ShopProvider.jsx'
import { useOrder } from '../../Providers/OrderProvider.jsx'
import { useNavigate } from 'react-router-dom'
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary.jsx'
import useCheckLicense from '../../Hooks/useCheckLicense.ts'
import { Licenses } from '../../Data/Licenses.ts'
import ScrollUpArrow from '../../Components/Components/ScrollUpArrow.jsx'
import MobileAccountNavBar from '../../Components/MobileComponents/NavBarMobile.jsx/MobileAccountNavBar.jsx'
import { useParams } from '../../Providers/ParamsProvider.jsx'
import Contractors from './Components/Contractors.jsx'
import { AccountCurrentView } from '../../Data/PageModeEnums.ts';
import NoAccess from '../../Components/NoAccess.jsx'


const ContractorsPageIndex = () => {
    const { checkLicense } = useCheckLicense()
    const [isValidLicense, setIsValidLicense] = useState(checkLicense([Licenses.TgInstalacje]))
    const { isMobile } = useParams()
    const navigate = useNavigate()
    const { setProductsFilter } = useShop()
    const { changeSelectedCustomer, authState } = useAuth()
    const [showMessageBoxQuestionPopup, setShowMessageBoxQuestionPopup] = useState(false)
    const [newSelectedContractor, setNewSelectedContractor] = useState(null)
    const [custIdToGeneratePriceList, setCustIdToGeneratePriceList] = useState(null)
    const { handleAddTaskForSendPriceList, handleAddTaskForSendPriceListNow } = useCustomer()
    const [contractorHasPriceList, setContractorHasPriceList] = useState(false)
    const { clearOrderInfo } = useOrder()
    const [showMessageCalculatePriceList, setShowMessageCalculatePriceList] = useState(false)

    const handleChangingContractorPopup = (answer) => {
        setShowMessageBoxQuestionPopup(false)
        if (answer) {
            changeSelectedCustomer(newSelectedContractor.custId, newSelectedContractor.siteId, newSelectedContractor.whId, newSelectedContractor.name, newSelectedContractor.fullName,
                '', newSelectedContractor.nip, newSelectedContractor.zipCode,
                newSelectedContractor.city, newSelectedContractor.street, newSelectedContractor.houseNum, newSelectedContractor.locumNum, newSelectedContractor.email, newSelectedContractor.phone,
                newSelectedContractor.dpl)
            setProductsFilter(prev => ({
                ...prev,
                SiteId: newSelectedContractor.siteId ? newSelectedContractor.siteId : '',
                WhId: newSelectedContractor.whId ? newSelectedContractor.whId : '',
            }))
            clearOrderInfo()
            if (handleAddTaskForSendPriceList(newSelectedContractor.custId)) {
                const message = newSelectedContractor.priceListGenerateDate === "0001-01-01T00:00:00" ? ' Kontrahent nie posiada wygenerowanego wcześniej cennika, generowanie nowego cennika może potrwać kilka minut.' : ''
                toast.success(`Wysłano zadanie tworzenia cennika dla wybranego kontrahenta. ${message}`)
            }
        }
    }
    const handleCalculatePriceListModal = async (answer) => {
        setShowMessageCalculatePriceList(false)
        if (answer) {
            const result = await handleAddTaskForSendPriceListNow(custIdToGeneratePriceList)
            if (!contractorHasPriceList) {
                toast.warning('Kontrahent nie posiada wygenerowanego wcześniej cennika, generowanie nowego cennika może potrwać kilka minut.')
            }
            if (!result) {
                toast.error('Nie udało się przeliczyć cennika dla wybranego kontrahenta')
            }
        }
    }
    const handleNavButtonClick = (buttonName) => {
        if (authState.selectedCustomer) {
            switch (buttonName) {
                case 'offer':
                    navigate('/OfferRequest/0/false')
                    break
                case 'orders':
                    navigate(`/orders`)
                    break
            }
        }
    }

    const offerButtonStyle = authState.selectedCustomer ? '' : 'btn-app-disabled'

    if (!authState || !authState.user || !authState.user.isOperator) {
        return <NoAccess />
    }
    return (
        <>
            <ErrorBoundary>
                <div>
                    <ScrollUpArrow />
                    <div className="container-fluid-with-paddings mt-4 mb-4">
                        {isMobile && <div className='mb-2'><MobileAccountNavBar currentKey={AccountCurrentView.Kontrahenci} /></div>}
                        <div className="main-container-holder" style={{ marginBottom: isMobile ? '90px' : '0px' }}>
                            <Contractors
                                setCustIdToGeneratePriceList={setCustIdToGeneratePriceList}
                                setShowMessageBoxQuestionPopup={setShowMessageBoxQuestionPopup}
                                setContractorHasPriceList={setContractorHasPriceList}
                                setNewSelectedContractor={setNewSelectedContractor}
                                setShowMessageCalculatePriceList={setShowMessageCalculatePriceList} />
                        </div>
                        {isValidLicense && <div className="row contractor-page-bottom-panel">
                            <div className="row mt-0 mt-md-4" style={{ marginBottom: isMobile ? '60px' : '10px' }}>
                                <div className="col-auto">
                                    <button className={`${offerButtonStyle} btn-app-primary`} onClick={() => handleNavButtonClick('offer')}>Oferta dla klienta</button>
                                </div>
                                <div className="col-auto mt-1 mt-md-0">
                                    <button className={`${offerButtonStyle} btn-app-secondary`} onClick={() => handleNavButtonClick('orders')}>Zamówienia dla klienta</button>
                                </div>
                                <div className="col-12 mt-2 mt-md-0 col-md-auto">
                                    <button className="btn-app-secondary btn-app-disabled">Dyspozycja - wypisanie dokumentów WZ</button>
                                </div>
                            </div>
                        </div>}
                    </div>

                    <YesNoMessageModal
                        show={showMessageBoxQuestionPopup}
                        onHide={handleChangingContractorPopup}
                        title={'UWAGA'}
                        message={'Masz niezakończone zlecenie. Czy na pewno chcesz zmienić kontrahenta? (Koszyk zostanie zapisany.)'}
                    />
                    <YesNoMessageModal
                        show={showMessageCalculatePriceList}
                        onHide={handleCalculatePriceListModal}
                        title={'UWAGA'}
                        message={'Czy na pewno chcesz wywołać natychmiastowe przeliczenie cennika dla wybranego kontrahenta?'}
                    />
                </div>
            </ErrorBoundary >
        </>
    )
}

export default ContractorsPageIndex